import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractService } from './abstract.service';
import { environment } from 'environments/environment';
import { Cliente } from 'app/dto/cliente.dto';
import { Page } from "app/dto/page.dto";
import { ProductoStock } from 'app/dto/producto-stock.dto';
import { DevolucionProductoStockDTO } from 'app/dto/devolucionProductoStock.dto';

@Injectable({
  providedIn: 'root'
})
export class ProductoStockService extends AbstractService<ProductoStock>{
  constructor(http: HttpClient) {
    super(http, environment.url_backend + 'producto-stock');
  }

  autocomplete(textoABuscar: string): Observable<ProductoStock[]> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("relations", "@proveedor(@persona()@empresa())@precio()@producto()");

    if (textoABuscar) {
      httpParams = httpParams.set("textoABuscar", textoABuscar.trim());
    }

    return this.http.get<ProductoStock[]>(this.urlServicio + "/autocomplete", { params: httpParams });
  }

  saveManual(dto: any): Observable<any> {
    return this.http.post<any>(this.urlServicio + "/manual", dto);
  }

  paginado(page: number, size: number, numeroPieza: string, idProveedor: number, enStock: boolean, estadoProductoStock: any, relations: string) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("page", page.toString());
    httpParams = httpParams.set("size", size.toString());

    if (numeroPieza) {
      httpParams = httpParams.set("numeroPieza", "" + numeroPieza.trim());
    }
    if (idProveedor) {
      httpParams = httpParams.set("idProveedor", "" + idProveedor);
    }
    if (estadoProductoStock) {
      httpParams = httpParams.set("estadoProductoStock", "" + estadoProductoStock.descripcion.trim());
    }
    if (enStock) {
      httpParams = httpParams.set("enStock", ""+enStock);
    }
    if (relations) {
      httpParams = httpParams.set("relations", relations);
    }
    return this.http.get<Page>(this.urlServicio + "/paginado", { params: httpParams });
  }

  findWorkflow(relations?: string): Observable<ProductoStock[]> {
    let httpParams = new HttpParams();
    if (relations) {
      httpParams = httpParams.set("relations", relations);
    }
    return this.http.get<ProductoStock[]>(this.urlServicio + "/workflow", { params: httpParams });
  }
  devolverAStock(dto: DevolucionProductoStockDTO): Observable<DevolucionProductoStockDTO> {
    return this.http.post<DevolucionProductoStockDTO>(this.urlServicio + "/devolver-a-stock",dto);
  }
  devolverAProveedor(dto: DevolucionProductoStockDTO): Observable<DevolucionProductoStockDTO> {
    return this.http.post<DevolucionProductoStockDTO>(this.urlServicio + "/devolver-a-proveedor",dto);
  }
}
